// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2G_Fa","label":"CategoryService_label__2Zdpb","location":"CategoryService_location__3Zenx"};